import { ScaleLoader } from 'react-spinners'

export default function Cargando() {
    return (
        <div className="min-h-96 flex items-center justify-center">
            <ScaleLoader width="2px" color="red" />
        </div>
    )
}
